export default "__VITE_ASSET__DZxa0B6c__"